import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function OfferSection() {
  return <section id="oferta" className="py-20 px-4 bg-gray-100" data-id="element-102">
      <div className="max-w-4xl mx-auto" data-id="element-103">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border-4 border-black" data-id="element-104">
          {/* Header */}
          <div className="bg-black text-white text-center py-8 px-4" data-id="element-105">
            <h2 className="text-4xl md:text-5xl font-black uppercase tracking-tight text-yellow-400" data-id="element-106">
              OFERTA ESPECIAL
            </h2>
            <p className="text-xl mt-2 font-bold" data-id="element-107">
              Hoy podés acceder a TODO el sistema completo
            </p>
          </div>

          <div className="p-8 md:p-12" data-id="element-108">
            {/* What you get */}
            <h3 className="text-2xl font-black text-gray-900 mb-6 uppercase border-b-2 border-gray-200 pb-4" data-id="element-109">
              Lo que te llevás hoy:
            </h3>
            <ul className="space-y-4 mb-10" data-id="element-110">
              {['Sistema Diario de Ventas', '100 Ideas de Contenido', 'Guiones de Venta', 'Megapack completo (Tomo 1 + 2)'].map((item, i) => <li key={i} className="flex items-center gap-4 text-xl md:text-2xl font-bold text-gray-800" data-id="element-111">
                  <CheckIcon className="w-8 h-8 text-green-500 flex-shrink-0" strokeWidth={3} data-id="element-112" />
                  {item}
                </li>)}
            </ul>

            {/* Pricing */}
            <div className="text-center bg-gray-50 p-8 rounded-2xl border-2 border-dashed border-gray-300 mb-10" data-id="element-113">
              <p className="text-gray-500 font-bold text-xl mb-2 uppercase" data-id="element-114">
                Valor Normal:
              </p>
              <p className="text-4xl md:text-5xl font-black text-red-500 line-through decoration-black decoration-4 mb-6" data-id="element-115">
                $49.990
              </p>

              <p className="text-gray-900 font-black text-2xl mb-2 uppercase" data-id="element-116">
                Precio Hoy:
              </p>
              <p className="text-6xl md:text-8xl font-black text-green-600 mb-4 drop-shadow-md" data-id="element-117">
                $19.990
              </p>
              <p className="text-sm font-bold text-gray-500 uppercase tracking-widest" data-id="element-118">
                Pago único • Acceso inmediato
              </p>
            </div>

            <CTAButton text="SÍ, QUIERO EL SISTEMA AHORA" data-id="element-119" />

            <div className="mt-6 flex justify-center items-center gap-4 opacity-70" data-id="element-120">
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Visa_Inc._logo.svg/2560px-Visa_Inc._logo.svg.png" alt="Visa" className="h-6" data-id="element-121" />
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Mastercard-logo.svg/1280px-Mastercard-logo.svg.png" alt="Mastercard" className="h-6" data-id="element-122" />
              <span className="font-bold text-sm text-gray-600" data-id="element-123">
                Pago 100% Seguro
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}